import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { httpAction } from '@/api/manage';
import { getAction } from '@/api/manage';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import Vue from 'vue';
var columns = [{
  dataIndex: 'postName',
  colName: 'post_name',
  title: '岗位类型名称',
  align: 'center',
  sorter: true,
  width: '20%',
  scopedSlots: {
    customRender: 'postName'
  }
}, {
  dataIndex: 'postCode',
  colName: 'post_code',
  title: '岗位类型编号',
  align: 'center',
  sorter: true,
  width: '15%',
  scopedSlots: {
    customRender: 'postCode'
  }
}, {
  dataIndex: 'component',
  colName: 'component',
  title: '前端组件',
  align: 'center',
  width: '15%',
  sorter: true,
  scopedSlots: {
    customRender: 'component'
  }
}, {
  dataIndex: 'homeUrl',
  colName: 'home_url',
  title: '前端路径',
  align: 'center',
  sorter: true,
  width: '15%',
  scopedSlots: {
    customRender: 'homeUrl'
  }
}, {
  dataIndex: 'status',
  colName: 'status',
  title: '状态',
  align: 'center',
  width: '15%',
  sorter: true,
  scopedSlots: {
    customRender: 'status'
  }
}, {
  title: '操作',
  dataIndex: 'operation',
  align: 'center',
  width: 120,
  scopedSlots: {
    customRender: 'operation'
  }
}];
var dataSource = []; // PS相关的KEY不能为title关键字

var addData1Index = 0;
export default {
  name: 'ConfigList',
  mixins: [JeecgListMixin],
  data: function data() {
    this.cacheData1 = dataSource.map(function (item) {
      return _objectSpread({}, item);
    });
    return {
      pagePath: '/sys/post/type',
      pageTitle: '岗位类型',
      tokenHeader: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)
      },
      // editable:false,
      // 表头
      dataSource: dataSource,
      addData1Index: addData1Index,
      columns: columns,
      disabled: false,
      editingKey: ''
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.loadData();
  },
  computed: {},
  methods: {
    loadData: function loadData(arg) {
      this.initTableData(arg);
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.records.length; i++) {
            var param = res.result.records[i];
            param.key = param.id;
            param.editable = false;
            paramList.push(param);
          }

          _this.dataSource = paramList;
          _this.ipagination.total = res.result.total;
        }

        if (res.code === 510) {
          _this.$notification.warning({
            message: res.message
          });
        }

        _this.loading = false;
      });
    },
    handleChange: function handleChange(value, key, column) {
      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.dataSource = newData;
      }
    },

    /**
     * 新增一个系统配置的相关参数
     */
    addTable: function addTable() {
      var newData = _toConsumableArray(this.dataSource);

      this.disabled = false;
      newData.push({
        key: 'A1_' + this.addData1Index,
        method: 'add',
        postCode: '',
        postName: '',
        component: '',
        homeUrl: '',
        status: '',
        editable: true
      });
      this.addData1Index = this.addData1Index + 1;
      this.dataSource = newData;
      this.cacheData1 = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },

    /**
     * table行输入保存
     * @param key
     */
    saveTable: function saveTable(key) {
      var _this2 = this;

      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target.postName != null && target.postName != '') {
        delete target.editable;
        target.status = target.status.toString();
        var method = 'put';

        if (target.method != null && target.method == 'add') {
          method = 'post';
        }

        httpAction(this.pagePath, target, method).then(function (res) {
          if (res.success) {
            _this2.$notification.success({
              message: res.message
            });

            _this2.queryParam = {};

            _this2.loadData();

            _this2.dataSource = newData;
            _this2.cacheData1 = newData.map(function (item) {
              return _objectSpread({}, item);
            });
          } else {
            _this2.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.$message.warning('请填写岗位类型名称');
      }

      this.editingKey = '';
    },

    /**
     * table行输入取消
     * @param key
     */
    cancelTable: function cancelTable(key) {
      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];
      this.editingKey = '';

      if (target) {
        Object.assign(target, this.cacheData1.filter(function (item) {
          return key === item.key;
        })[0]);
        delete target.editable;
        this.dataSource = newData;
      }
    },

    /**
     * table行删除
     * @param key
     */
    delTable: function delTable(key) {
      var newData = this.dataSource.filter(function (item) {
        return key != item.key;
      });
      var docItem = this.dataSource.find(function (item) {
        return key == item.key;
      });

      if (docItem.postName != null && docItem.postName != '') {
        this.handleDelete(docItem.id);
      }

      this.dataSource = newData;
      this.cacheData1 = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },

    /**
     * table行编辑
     * @param key
     */
    editTable: function editTable(key) {
      this.disabled = true;

      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];
      this.editingKey = key;

      if (target) {
        target.editable = true;
        this.dataSource = newData;
      }
    }
  }
};